/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { DocArrowConvertIcon16Light } from './DocArrowConvertIcon16Light';
import { DocArrowConvertIcon16Regular } from './DocArrowConvertIcon16Regular';
import { DocArrowConvertIcon16Solid } from './DocArrowConvertIcon16Solid';
import { DocArrowConvertIcon20Light } from './DocArrowConvertIcon20Light';
import { DocArrowConvertIcon20Regular } from './DocArrowConvertIcon20Regular';
import { DocArrowConvertIcon20Solid } from './DocArrowConvertIcon20Solid';
import { DocArrowConvertIcon24Regular } from './DocArrowConvertIcon24Regular';
import { DocArrowConvertIcon24Solid } from './DocArrowConvertIcon24Solid';
import { DocArrowConvertIcon32Regular } from './DocArrowConvertIcon32Regular';
import { DocArrowConvertIcon64Regular } from './DocArrowConvertIcon64Regular';
var sizes = {
    16: {
        light: DocArrowConvertIcon16Light,
        regular: DocArrowConvertIcon16Regular,
        solid: DocArrowConvertIcon16Solid,
    },
    20: {
        light: DocArrowConvertIcon20Light,
        regular: DocArrowConvertIcon20Regular,
        solid: DocArrowConvertIcon20Solid,
    },
    24: {
        regular: DocArrowConvertIcon24Regular,
        solid: DocArrowConvertIcon24Solid,
    },
    32: {
        regular: DocArrowConvertIcon32Regular,
    },
    64: {
        regular: DocArrowConvertIcon64Regular,
    },
};
export var DocArrowConvertIcon = forwardRef('DocArrowConvertIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
